import React, {useRef} from "react";
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import {observer} from "mobx-react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {useStores} from "../../Hooks";

const CropperDialog = observer(() => {
    const {modalStore, generalStore} = useStores();
    const cropperRef = useRef();

    const {currentlyCroppedImage, aspectRatio} = modalStore.modalData;

    function closeModal() {
        modalStore.isCropperModalOpen = false;
    }

    async function save() {
        try {
            generalStore.isLoaderOpen = true;
            const imageCanvas = cropperRef.current.cropper.getCroppedCanvas();
            const blob = await new Promise(resolve => imageCanvas.toBlob(blob => resolve(blob)));
            const {fileFullName, oldFileId, projectId} = modalStore.modalData;

            blob.name = fileFullName;
            const [fileData] = await generalStore.uploadFiles([blob], projectId);

            generalStore.isLoaderOpen = true; // upload file closes loader
            if (oldFileId) {
                try {
                    await generalStore.deleteFile(oldFileId);
                } catch (e) {
                    modalStore.showInfoMessage(generalStore.translate('couldNotDeletePreviousFIle'))
                }
            }

            await modalStore.modalData.saveMethod(fileData.FileId, fileData.ThumbnailFileAddress);
            closeModal();
        } catch (e) {
            console.error(e);
            modalStore.showErrorMessage(generalStore.translate('cannotSaveImage'));
        }
        generalStore.isLoaderOpen = false;
    }

    function renderCropper() {
        return (
            <Cropper
                ref={cropperRef}
                src={currentlyCroppedImage}
                style={{height: 400, width: '100%'}}
                aspectRatio={aspectRatio}
                guides={false}
                ready={() => {
                    try {
                        const {width, left} = cropperRef.current.cropper.getCropBoxData();
                        cropperRef.current.cropper.setCropBoxData({height: 400});
                        const {width: newWidth} = cropperRef.current.cropper.getCropBoxData();
                        const newLeft = left - (newWidth - width) / 2;
                        cropperRef.current.cropper.setCropBoxData({width: newWidth, left: newLeft});
                    } catch (e) {
                        console.error(e);
                    }
                }}
                // crop={crop}
            />
        );
    }

    return (
        <Dialog
            className='dialog'
            open={modalStore.isCropperModalOpen}
            onClose={closeModal}
            fullWidth
            maxWidth='md'
        >
            <DialogTitle className="dialog-description">{generalStore.translate('imageCropper')}</DialogTitle>
            <DialogContent>
                {renderCropper()}
            </DialogContent>

            <DialogActions>
                <Button color="primary" onClick={save}>{generalStore.translate('uploadImage')}</Button>
                <Button color="error" onClick={closeModal}>{generalStore.translate('cancel')}</Button>
            </DialogActions>
        </Dialog>
    );
});

export default CropperDialog;
